// extracted by mini-css-extract-plugin
export default {"viewInfoList":"ViewInfoList_viewInfoList__9YQzC","title":"ViewInfoList_title__9Dzl9","infoList":"ViewInfoList_infoList__lErUH","linkItem":"ViewInfoList_linkItem__mO2pd"};